import { AlertDialog } from "radix-ui";
import { ReactNode } from "react";

const ConfirmPopupLayout = ({
  isOpen,
  onClose,
  children,
  initialFocusRef,
}: {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  initialFocusRef: React.RefObject<HTMLElement>;
}) => {
  return (
    <AlertDialog.Root
      open={isOpen}
      onOpenChange={(open) => !open && onClose()}
    >
      <AlertDialog.Portal>
        <AlertDialog.Content
          className="fixed left-1/2 top-1/2 z-[100] max-h-[max-content] w-[350px] -translate-x-1/2 -translate-y-1/2 transform rounded-[6px] border border-solid border-25 bg-20 shadow-lg"
          onClick={(e) => e.stopPropagation()}
          onOpenAutoFocus={(e) => {
            e.preventDefault();
            if (initialFocusRef.current) {
              initialFocusRef.current.focus();
            }
          }}
        >
          {children}
        </AlertDialog.Content>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  );
};

export default ConfirmPopupLayout;
